// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateProductAttribute_closeButton__2YpAN"};